<nav class="sticky top-0 z-50 dashboard-header">
  <div class="flex items-center justify-between px-6 py-3 mx-auto max-w-screen-2xl">
    <!-- Right: Logo -->
    <a routerLink="/dashboard" dir="ltr" lang="en" class="logo-wrap shrink-0">
      <img src="/images/logo.png" alt="Awalan" class="logo" />
    </a>

    <div class="justify-center flex-1 hidden md:flex">
      <ul
        class="flex items-center gap-10 text-white hover:text(--color-main) transition-all duration-300"
      >
        <li>
          <a
            routerLink="/dashboard"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            لوحة التحكم
          </a>
        </li>

        <li>
          <a routerLink="/dashboard/my-investment" routerLinkActive="active-link"> تعاقداتي </a>
        </li>

        <li>
          <a routerLink="/dashboard/projects" routerLinkActive="active-link"> جميع المشاريع </a>
        </li>

        <li>
          <a routerLink="/dashboard/wallet" routerLinkActive="active-link"> المحفظة </a>
        </li>
      </ul>
    </div>

    <!--  Lang -->
    <div class="items-center hidden gap-5 md:flex shrink-0 left-side">
      <!-- User -->
      <a routerLink="/dashboard/userProfile" class="user-box">
        <i class="text-5xl fa-solid fa-circle-user"></i>
        <div class="user-text">
          <span class="user-name">{{ shortName }} </span>
          <span class="user-role">متعاقد</span>
        </div>
      </a>
      <div class="divider"></div>

      <div class="items-center hidden gap-4 md:flex shrink-0">
        <button
          routerLink="/"
          class="bg-(--color-main) text-(--color-secondary) h-10 px-10 rounded-[10px] font-semibold transition hover:bg-white hover:border-(--color-main) cursor-pointer"
        >
          العودة للموقع الرئيسي
        </button>
      </div>

      <!-- Language -->
      <div class="relative lang-toggle">
        <button type="button" (click)="toggleLang()" class="lang-btn">
          <span>{{ currentLang.toUpperCase() }}</span>
          <svg class="w-4 h-4" fill="none" viewBox="0 0 10 6">
            <path stroke="currentColor" stroke-width="2" d="m1 1 4 4 4-4" />
          </svg>
        </button>

        <div class="lang-menu" [class.hidden]="!isLangOpen">
          <button (click)="setLang('en')" class="lang-item">EN</button>
          <button (click)="setLang('ar')" class="lang-item">AR</button>
        </div>
      </div>
    </div>

    <!-- Mobile Toggle -->
    <button type="button" (click)="toggleMobileMenu()" class="md:hidden mobile-toggle">☰</button>
  </div>

  <div class="header-line"></div>
</nav>

@if (isMobileMenuOpen) {
  <div class="fixed inset-0 z-50 md:hidden mobile-menu-bg">
    <div class="flex items-center justify-between px-6 py-4 border-b border-white/20">
      <img src="/images/website-logo-v2.png" class="h-12" alt="Awalan" />
      <button
        type="button"
        (click)="toggleMobileMenu()"
        class="w-10 h-10 text-white rounded-lg hover:bg-white/10"
      >
        ✕
      </button>
    </div>

    <div class="px-6 py-8 space-y-6 text-lg text-right text-white">
      <div class="relative lang-toggle">
        <button
          type="button"
          (click)="toggleLang()"
          class="w-full bg-white text-[#243B7A] px-4 py-3 rounded-md text-sm inline-flex items-center justify-between cursor-pointer"
        >
          <span>{{ currentLang.toUpperCase() }}</span>
          <svg class="w-4 h-4" fill="none" viewBox="0 0 10 6">
            <path stroke="currentColor" stroke-width="2" d="m1 1 4 4 4-4" />
          </svg>
        </button>

        <div class="w-full mt-2 bg-white rounded-md shadow" [class.hidden]="!isLangOpen">
          <button
            (click)="setLang('en')"
            class="block w-full text-right px-4 py-3 text-[#243B7A] hover:bg-gray-100"
          >
            EN
          </button>
          <button
            (click)="setLang('ar')"
            class="block w-full text-right px-4 py-3 text-[#243B7A] hover:bg-gray-100"
          >
            AR
          </button>
        </div>
      </div>

      <a
        routerLink="/dashboard"
        (click)="isMobileMenuOpen = false"
        routerLinkActive="text-lime-400"
        [routerLinkActiveOptions]="{ exact: true }"
        class="block"
      >
        لوحة التحكم
      </a>

      <a
        routerLink="/dashboard/my-investment"
        (click)="isMobileMenuOpen = false"
        routerLinkActive="text-lime-400"
        class="block"
      >
        تعاقداتي
      </a>

      <a
        routerLink="/dashboard/projects"
        (click)="isMobileMenuOpen = false"
        routerLinkActive="text-lime-400"
        class="block"
      >
        جميع المشاريع
      </a>

      <a
        routerLink="/dashboard/wallet"
        (click)="isMobileMenuOpen = false"
        routerLinkActive="text-lime-400"
        class="block"
      >
        المحفظة
      </a>

      <a routerLink="/dashboard/userProfile" (click)="isMobileMenuOpen = false" class="block">
        الملف الشخصي
      </a>

      <button
        routerLink="/"
        class="bg-(--color-main) text-(--color-secondary) h-10 px-10 rounded-[10px] font-semibold transition hover:bg-white hover:border-(--color-main) cursor-pointer"
      >
        العودة للموقع الرئيسي
      </button>
    </div>
  </div>
}
